<template>
    <div>
        <!-- 侧边栏 -->
        <!-- <sider-list-1
            ref="side"
            :barList="barList"
            :groupBarOnline="groupBarOnline"
            :groupBarSum="groupBarSum"
        ></sider-list-1> -->
        <!-- 右侧主要内容 -->
        <!-- <div class="home-content scrollStyle" ref="content"> -->
        <div ref="box">
            <bar-content
                ref="barContent"
                @setDirectAndSpareModal="setDirectAndSpareModal"
            ></bar-content>
        </div>
        <set-direct-and-spare-modal
            ref="setDirectAndSpareModal"
        ></set-direct-and-spare-modal>
    </div>
</template>

<script>
// 左侧侧边栏
// import SiderList1 from "./siderList1";
// 右侧内容
import BarContent from "./barContent";
// 备用直连远程模态窗
import SetDirectAndSpareModal from "./modals/setDirectAndSpareModal";
import { mapActions } from "vuex";

export default {
    name: "barManager",
    components: {
        // SiderList1,
        BarContent,
        SetDirectAndSpareModal
    },
    data() {
        return {
            barList: [],
            barId: "",
            groupName: ""
            // groupBarSum: "",
            // groupBarOnline: ""
        };
    },
    mounted() {
        // this.$domFn.addAnimateClass(this.$refs.content, 'animated zoomInLeft')
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.init(vm.$route.params.id);
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.init(to.params.id);
        next();
    },
    methods: {
        init(barId) {
            this["barDetails/actionUpdateBarInfo"](barId);
        },
        ...mapActions(["barDetails/actionUpdateBarInfo"]),
        setDirectAndSpareModal() {
            this.$refs.setDirectAndSpareModal.init();
        }
    }
};
</script>

<style lang="scss" scoped>
.home-content {
    position: absolute;
    min-width: 940px;
    left: 200px;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: auto;
}
</style>
